import { currentSession } from '@/utils/auth';

// WriteRoles - These roles have access to click on a component or used to make something visible or hidden
// ReadRoles - They are currently setup but are not being used in the logic but were defined and here for future usage
const action_roles = {
  EDIT_GAMEPLAN: {
    readRoles: ['SUP'],
    writeRoles: ['MGR'],
  },
  OS_ADD_NEW_USER: {
    readRoles: [],
    writeRoles: ['ADM'],
  },
  VIEW_USER_PROFILE: {
    readRoles: [],
    writeRoles: ['SUP', 'MGR'],
  },
  REQUEST_WORK: {
    readRoles: [],
    writeRoles: ['REP', 'MGR'],
  },
  // Documents -> Appeal Letters
  GENERATE_DOCUMENTS: {
    readRoles: [],
    writeRoles: ['REP', 'ADM', 'MGR'],
  },
  // Documents -> Appeal Letters
  VIEW_DOCUMENTS: {
    readRoles: [],
    writeRoles: ['REP', 'ADM', 'MGR'],
  },
  WORKITEM_SEARCH: {
    readRoles: [],
    writeRoles: ['REP', 'ADM', 'MGR', 'SUP'],
  },
  ADD_NOTES: {
    readRoles: [],
    writeRoles: ['REP', 'ADM', 'MGR', 'SUP'],
  },
  COMPLETE_WORK_ITEMS: {
    readRoles: [],
    writeRoles: ['REP', 'MGR'],
  },
  CHECK_CLAIM_STATUS: {
    readRoles: ['SUP'],
    writeRoles: ['REP', 'ADM', 'MGR'],
  },
  CHAT_AI: {
    readRoles: ['SUP', 'REP', 'ADM', 'MGR'],
    writeRoles: ['REP', 'ADM', 'MGR'],
  },
  EDIT_USER_GOALS: {
    readRoles: [],
    writeRoles: ['MGR', 'SUP'],
  },
};

let active_user_roles = null;

function getActiveRoles() {
  if (active_user_roles) {
    return active_user_roles;
  }

  const token = currentSession() || {};
  active_user_roles = token['cognito:groups'] || [];
  return active_user_roles;
}

export function useRbac() {
  function hasWriteRole(action) {
    const writeRoles = action_roles[action]?.writeRoles || [];
    return getActiveRoles().some(role => writeRoles.includes(role));
  }

  function resetActiveUserRoles() {
    active_user_roles = null;
  }

  return {
    action_roles,
    hasWriteRole,
    resetActiveUserRoles,
    getActiveRoles,
  };
}
